import store from './channelsStore';
import 'flag-icon-css/css/flag-icon.min.css';
import Vue from 'vue';

const CHANNEL_PLUGIN_MODAL_SESSION_KEY = 'CHANNEL_MODAL_CLOSED';

const channelPlugin = {
    parseChannelUrls(channel) {
        return channel.url.split(',').map(url => url.trim())
    },
    channelIncludesUrl(channel, url) {
        let channelUrls = channelPlugin.parseChannelUrls(channel);
        return channelUrls.indexOf(url) !== -1 ||
            channelUrls.indexOf(url.replace('http://', '')) !== -1 ||
            channelUrls.indexOf(url.replace('https://', '')) !== -1;
    },
    getCurrentChannel() {
        return store.state.currentChannel;
    },
    getShowChannelSwitcher() {
        return store.state.showChannelSwitcher;
    },
    setShowChannelSwitcher(value) {
        store.commit('setShowChannelSwitcher', value);
        Vue.$session.set(CHANNEL_PLUGIN_MODAL_SESSION_KEY, value);
    },
};

export default {
    install(Vue) {
        channelPlugin.store = store;

        if (!Vue.$session.exists(CHANNEL_PLUGIN_MODAL_SESSION_KEY)) {
            channelPlugin.loadingPromise = store.dispatch('loadChannels').then(() => {
                Vue.$countryDetectService.detectCountry().then(country => {
                    const currentCountry = Vue.$country.getCountryBy('iso_2', country);

                    store.state.channels.some((channel) => {
                        if (channelPlugin.channelIncludesUrl(channel, location.origin)) {
                            store.commit('setCurrentChannel', channel);

                            if (
                                channel.countries &&
                                channel.countries.length &&
                                (
                                    !currentCountry ||
                                    !channel.countries.includes(currentCountry.id)
                                ) &&
                                channel.channel_redirects.length
                            ) {
                                store.commit('setShowChannelSwitcher', true);
                            }

                            return true;
                        }
                    });
                });
            });
        }

        Vue.$channel = channelPlugin;
        Vue.prototype.$channel = channelPlugin;
    },
};